import { PlaceActionType } from './place-action-type';

export interface CreatePlaceSuccessAction {
  placeKey: string;
  type: PlaceActionType.CreatePlaceSuccess;
}

export const createPlaceSuccess = (
  placeKey: string,
): CreatePlaceSuccessAction => ({
  placeKey,
  type: PlaceActionType.CreatePlaceSuccess,
});
